// The five organisation filters: Business Unit, Department, Location, Cost Centre, Legal Entity.
// Pass the object returned by hooks/useOrgFilters. `fields` limits which dropdowns are shown (default: all five).
// [UPDATED] PM-18: every filter is a checkbox dropdown, so several values can be chosen at once.
// Values in one filter are combined with OR; the filters are combined with AND (they narrow each other).
import MultiSelect from "./MultiSelect";
import { NONE, ORG_FILTER_FIELDS } from "../../utils/orgFilters";

// [NEW] `marks` = { [filterKey]: { [value]: { done, total } } } shows how many of an option's people are already chosen:
// everyone -> "✓ All 10 in cycle" (green), some -> "3 / 10 in cycle", nobody -> nothing.
// (e.g. marks={{ departmentId: { 3: { done: 3, total: 10 } } }} markLabel="in cycle").
export default function OrgFilters({ org, fields, className = "", compact = false, showClear = true, marks, markLabel = "selected" }) {
  const shown = ORG_FILTER_FIELDS.filter((f) => !fields || fields.includes(f.key));
  return (
    <>
      {shown.map((f) => {
        const items = org.options[f.list] || [];
        const mark = (value) => {
          const { done = 0, total = 0 } = marks?.[f.key]?.[value] || {};
          if (!done) return {};
          return done >= total
            ? { hint: `✓ All ${total} ${markLabel}`, hintTone: "full" }
            : { hint: `${done} / ${total} ${markLabel}`, hintTone: "partial" };
        };
        const options = items.map((it) => {
          const value = typeof it === "string" ? it : it.id;
          return { value, label: typeof it === "string" ? it : it.name, ...mark(value) };
        });
        return (
          <MultiSelect
            key={f.key}
            label={f.label}
            allLabel={f.all}
            options={options}
            pinned={[{ value: NONE, label: f.none, ...mark(NONE) }]}
            value={org.filters[f.key]}
            onChange={(values) => org.set(f.key, values)}
            compact={compact}
            className={className}
          />
        );
      })}
      {showClear && org.active && (
        <button type="button" className="btn btn-ghost btn-sm org-filter-clear" onClick={org.clear}>Clear filters</button>
      )}
    </>
  );
}